// extracted by mini-css-extract-plugin
export default {"actionsCell":"ActionsCell_actionsCell__hwHxm"};